import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

export default function PrivacyPolicyScreen() {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.resolvedLanguage;

  const SECTIONS = [
    { id: 1, rows: 2 },
    { id: 2, rows: 4 },
    { id: 3, rows: 4 },
    { id: 4, rows: 4 },
    { id: 5, rows: 2 },
    { id: 6, rows: 2 },
    { id: 7, rows: 13 },
    { id: 8, rows: 15 },
    { id: 9, rows: 12 },
    { id: 10, rows: 24 },
    { id: 11, rows: 11 },
    { id: 12, rows: 7 },
    { id: 13, rows: 6 },
  ];

  return (
    <Container>
      <div className="container small-container">
        <title>{t('privacy-policy-screen-helmet')}</title>

        <h1 className="screen-heading">{t('privacy-policy-screen-heading')}</h1>

        <Row className="text-container">
          <Col>
            {SECTIONS.map(({ id, rows }) => (
              <div key={id} className="text-container-section">
                <h4>{t(`privacy-policy-screen-section-${id}-heading`)}</h4>

                {Array.from({ length: rows }, (_, i) => (
                  <p
                    key={i}
                    className="privacy-policy-content"
                    dangerouslySetInnerHTML={{
                      __html: t(
                        `privacy-policy-screen-section-${id}-row-${i + 1}`
                      ),
                    }}
                  />
                ))}
              </div>
            ))}

            {selectedLanguage !== 'de' && (
              <p className="translation-info">
                <i>{t('privacy-policy-screen-translation-info')}</i>
              </p>
            )}
          </Col>
        </Row>
      </div>
    </Container>
  );
}
